import type { Rect } from "../types/C1_AppTypes";

/** Move only vertices on the outer bounds, keeping recesses in place. */
export function polygonBoundsTransform(points: readonly { x: number; y: number }[], bounds: Rect, requested: Rect) {
  const epsilon = 0.000001;
  const axis = (key: "x" | "y", low: number, high: number, nextLow: number, nextHigh: number) => {
    const inner = points.map(point => point[key]).filter(value => value > low + epsilon && value < high - epsilon);
    // Keep at least one centimetre before an interior corner, so no edge reverses.
    if (inner.length) {
      const first = Math.min(...inner);
      const last = Math.max(...inner);
      nextLow = Math.min(nextLow, first - Math.min(0.01, (first - low) / 2));
      nextHigh = Math.max(nextHigh, last + Math.min(0.01, (high - last) / 2));
    }
    return (value: number) => Math.abs(value - low) < epsilon ? nextLow : Math.abs(value - high) < epsilon ? nextHigh : value;
  };
  const x = axis("x", bounds.x1, bounds.x2, requested.x1, requested.x2);
  const y = axis("y", bounds.y1, bounds.y2, requested.y1, requested.y2);
  return (point: { x: number; y: number }) => ({ x: x(point.x), y: y(point.y) });
}
